// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  WEB_URL: 'https://lockers.liiteri.net/',
  API_URL: "https://lockers-api.liiteri.net/api/",
  AUTH_URL : "https://openid.coreorient.com/api/",
  AWS_REGION:'eu-west-1',
  AWS_BUCKET:'lockers-laravel'
};
